/**
 * A simple wrapper around fetch to handle base URLs and authentication tokens.
 */
export const apiClient = async (url, options = {}) => {
  const token = localStorage.getItem("token");
  
  const headers = {
    "Content-Type": "application/json",
    ...options.headers,
  };

  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  const response = await fetch(url, {
    ...options,
    headers,
  });

  if (response.status === 401 || response.status === 403) {
    // Token expired or invalid
    localStorage.removeItem("token");
    window.location.href = "/";
  }

  return response;
};

export const apiFormDataClient = async (url, options = {}) => {
  const token = localStorage.getItem("token");
  
  const headers = {
    ...options.headers,
  };

  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  const response = await fetch(url, {
    ...options,
    headers,
  });

  if (response.status === 401 || response.status === 403) {
    // Token expired or invalid
    localStorage.removeItem("token");
    window.location.href = "/";
  }

  return response;
};
